<!--
 * @Author: wsx
 * @Date: 2022-01-22 15:31:21
 * @LastEditTime: 2022-01-22 16:07:28
 * @LastEditors: your name
 * @Description: 标题
-->

<script >
import { h } from 'vue';

export default {
  name: 'HTitle',
  setup(props, context) {
    return () => h('div', { class: 'HTitle' }, [
      h('i', { class: 'icon' }, ''),
      h('span', {}, context.slots)
    ]);
  }
};
</script>
<style  lang='scss' scoped >
.HTitle {
  @include flex-row-s-c;
  .icon{
    display: inline-block;
    width: 5px;
    height: 16px;
    margin-right: 5px;
    background-color: var(--el-color-primary);
  }
}
</style>